module.exports = __webpack_public_path__ + "img/calendar-regular.122ef343.svg";